import { useCallback } from 'react';
import { useOpenTask } from '../../services/index.tsx';
import { useMarkAsCompleteAndExpand } from '../mark-as-complete-and-expand/index.tsx';

export const useMarkOpenTaskFromEligibleTasksAsCompleteAndExpand = (eligibleTasks: string[]) => {
	const markComplete = useMarkAsCompleteAndExpand();
	const [openTask] = useOpenTask();

	return useCallback(() => {
		if (openTask === null || eligibleTasks.includes(openTask) === false) {
			return;
		}
		markComplete(openTask);
	}, [eligibleTasks, markComplete, openTask]);
};
